import MoneyEnvelope from 'src/assets/svg/money_envelope.svg';
import { Clickable } from 'src/shared/design-system/Utilities';
import styled from 'styled-components';
import { Border, Colors, Font, Mixins, ScreenWidth, ScreenWidthValues, Spacing } from 'web-common/src/shared/styles';

export const Container = styled(Clickable)`
  cursor: pointer;
  display: block;
  font-family: ${Font.Family.SANS};
  margin: 0 auto ${Spacing.DOUBLE} auto;
  padding: 0 ${Spacing.SINGLE};
  text-decoration: none;

  ${Mixins.Media.minWidthSmall(`
    width: 750px;
    padding: 0 ${Spacing.SINGLE};
    margin: 0 auto ${Spacing.SINGLE_HALF} auto;
  `)}
  ${Mixins.Media.minWidthLarge(`width: 1140px !important;`)}
`;

export const Wrapper = styled.div`
  align-items: center;
  background: ${Colors.KALE_LITE_30};
  border-radius: ${Border.Radius.M};
  color: ${Colors.BLACK};
  display: flex;
  gap: ${Spacing.SINGLE};
  justify-content: space-between;
  margin: auto;
  padding: ${Spacing.SINGLE};
  flex-direction: row;

  @media only screen and (min-width: ${ScreenWidthValues[ScreenWidth.SMALL]}px) {
    text-align: center;
    justify-content: center;
  }

  ${Mixins.Media.maxWidthSmall(`
    gap: ${Spacing.HALF};
  `)}
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  font-size: ${Font.Size.L};
  font-weight: 500;
  justify-content: center;
  gap: ${Spacing.HALF};
  text-decoration: none !important;

  ${Mixins.Media.maxWidthSmall(`font-size: ${Font.Size.XL};`)}
`;

export const HeaderImage = styled.img.attrs(() => ({ src: MoneyEnvelope }))`
  width: ${Spacing.QUADRUPLE};
  height: ${Spacing.QUADRUPLE};
  margin-left: ${Spacing.SINGLE};
  object-fit: contain;
`;

export const SpacerDiv = styled.div`
  display: none;

  @media only screen and (min-width: ${ScreenWidthValues[ScreenWidth.SMALL]}px) {
    display: block;
    width: ${Spacing.QUADRUPLE};
    height: ${Spacing.QUADRUPLE};
    margin-right: ${Spacing.SINGLE};
  }
`;
